/*
 * Scenario: insert-heading
 *
 * Wie insert-after-cursor, aber der eingefuegte Absatz ist ein Heading 1.
 * Browser-Test-Anker fuer Block-Format-Wechsel im Insert-Pfad (Composite
 * zeigt H1-Groesse + Bold-Floor an der virtuellen Insert-Zeile).
 */

import { emit, wait, resolve, payloadFromMarkdown } from './_helpers.js'

export const name = 'insert-heading'
export const description = 'Insert a heading 1 after the cursor (composite renderer demo).'

export async function run(state) {
    const toolCallId = 'tu_insh_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-insert-heading' }, 0)
    await emit(state, 'thinking', { text: 'A heading would frame the next scene…' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    const afterParagraphId = resolve(state, '$cursor.paragraphId')
    const baseVersion = resolve(state, '$cursor.version')

    const patch = payloadFromMarkdown('# Neuer Abschnitt', 'text')

    await emit(state, 'proposeInsert', {
        toolCallId,
        afterParagraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        newText: patch.text,
        newFormats: patch.formats,
        newLinks: patch.links,
        newHeadingLevel: patch.headingLevel,
        newListType: patch.listType,
        newListLevel: patch.listLevel,
        newBlockquote: patch.blockquote,
        reason: 'Adds a clear scene break.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Heading inserted. Want me to look at the next break?'
            : 'Okay, no heading. The flow stays as it is.'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
